import { Link } from '@/navigation'

export default function DynamicLink({
  children,
  isLinkTag = true,
  prefetch,
  locale = 'must-set-locale-for-DynamicLink',
  ...props
}) {
  const isFullURL = props.href.includes('http')
  if (isLinkTag) {
    return (
      <Link prefetch={prefetch} {...props}>
        {children}
      </Link>
    )
  }
  return (
    <a
      rel="noopener noreferrer"
      {...props}
      href={isFullURL ? props.href : `/${locale}${props.href}`}
    >
      {children}
    </a>
  )
}
